export default __webpack_public_path__ + "static/media/cloudezsmtp-negative.00b1a78b.svg";